import {memo} from 'react';
import styles from './ErrorMessage.module.scss';

export const ErrorMessage = memo(({text}: {text: string}) => {
  return <p className={styles.errorMessage}>{text}</p>;
});
ErrorMessage.displayName = 'ErrorMessage';
